export enum AmmSideTypes {
    Exit = 'Exit',
    Join = 'Join'
}
